import { useLocation, useNavigate } from "react-router-dom";
import { ArrowNarrowLeft } from "src/assets/icons/arrow-narrow-left";
import { Home4 } from "src/assets/icons/home-04";
import {
  Container,
  Body,
  SectionTitle,
  Title,
  Description,
  Footer,
  FooterLink,
  ButtonGroup,
  PorchPassLogo,
  LogoLink,
  TopGradient,
} from "./ErrorPage.styles";
import { currentYear } from "src/constants";
import { Logo } from "src/components/Logo";
import { usePageView } from "src/hooks/usePageView";
import { GhostButton, PrimaryButton } from "src/components/Buttons";

const statusMap = {
  403: {
    title: "Forbidden",
    description: "Sorry, you don’t have permission to access this page.",
  },
  404: {
    title: "Page not found.",
    description: "Sorry, we couldn’t find the page you’re looking for.",
  },
};

export default function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const status: keyof typeof statusMap = location.state?.status || 404;
  usePageView(`${status} Error`);
  const { title, description } = statusMap[status] || statusMap[404];

  return (
    <>
      <TopGradient />
      <Container>
        <PorchPassLogo>
          <LogoLink to="/">
            <Logo />
          </LogoLink>
        </PorchPassLogo>
        <Body>
          <SectionTitle>{status} ERROR</SectionTitle>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <ButtonGroup>
            <GhostButton onClick={() => window.history.back()}>
              <ArrowNarrowLeft width={18} height={18} /> Go back
            </GhostButton>
            <PrimaryButton initialBg={true} onClick={() => navigate("/")}>
              Return home
              <Home4 color="white" width={18} height={19} />
            </PrimaryButton>
          </ButtonGroup>
        </Body>

        <Footer>
          <FooterLink target="_blank" to="https://www.porchpass.com/privacy">
            Privacy
          </FooterLink>
          <FooterLink target="_blank" to="https://www.porchpass.com/terms">
            Terms of use
          </FooterLink>
          <FooterLink target="_blank" to="https://www.porchpass.com/contact">
            Support
          </FooterLink>
          <span>© {currentYear} PorchPass Inc.</span>
        </Footer>
      </Container>
    </>
  );
}
